import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { BsShieldCheck, BsAward, BsTruck, BsPeopleFill } from 'react-icons/bs';
import './aboutus.css';

const stats = [
  { icon: <BsAward size={22} />, value: '15+', label: 'Years Experience' },
  { icon: <BsPeopleFill size={22} />, value: '50K+', label: 'Happy Customers' },
  { icon: <BsShieldCheck size={22} />, value: '100%', label: 'Licensed & Safe' },
  { icon: <BsTruck size={22} />, value: '500+', label: 'Products' },
];

const MAP_SRC =
  'https://maps.google.com/maps?q=9.3272017,77.7619017&hl=en&z=17&output=embed';

const MAP_LINK =
  'https://www.google.com/maps/place/@9.3272017,77.7619017,17z/data=!3m1!4b1!4m4!3m3!8m2!3d9.3272017!4d77.7619017?hl=en';

export const Aboutus = () => {
  return (
    <section className="about" id="about">
      {/* Decorative top wave */}
      <div className="about__wave">
        <svg viewBox="0 0 1440 60" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0,30 C360,60 1080,0 1440,30 L1440,0 L0,0 Z" fill="#f5f5f5" />
        </svg>
      </div>

      <Container fluid className="px-4 px-md-5">
        <Row className="align-items-center g-5">

          {/* ── Left — Content ── */}
          <Col xs={12} lg={6}>
            <div className="about__content">
              <span className="about__tag">Who We Are</span>
              <h2 className="about__title">
                Lighting Up Celebrations<br />
                <span>Since Over a Decade</span>
              </h2>
              <p className="about__para">
                SmartCrackers is a trusted name in the fireworks industry, rooted in the heart of Sivakasi — India's fireworks capital. We bring you a curated collection of premium, safe, and vibrant crackers for every occasion, from Diwali and New Year to weddings and birthdays.
              </p>
              <p className="about__para">
                Every product in our store is sourced from licensed manufacturers, tested for safety, and packed with care. We believe celebrations should be joyful, bright, and worry-free — and that's exactly what we deliver.
              </p>

              {/* Stats */}
              <div className="about__stats">
                {stats.map((s) => (
                  <div key={s.label} className="about__stat">
                    <span className="about__stat-icon">{s.icon}</span>
                    <span className="about__stat-value">{s.value}</span>
                    <span className="about__stat-label">{s.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </Col>

          {/* ── Right — Map ── */}
          <Col xs={12} lg={6}>
            <div className="about__map-wrap">
              <span className="about__map-corner about__map-corner--tl" aria-hidden="true" />
              <span className="about__map-corner about__map-corner--br" aria-hidden="true" />

              <div className="about__map-panel">
                <div className="about__map-frame">
                  <iframe
                    title="SmartCrackers Location"
                    src={MAP_SRC}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  />
                </div>

                <a
                  href={MAP_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="about__address-card"
                >
                  <span className="about__address-pin" aria-hidden="true">📍</span>
                  <div className="about__address-body">
                    <p className="about__address-title">Find Us Here</p>
                    <p className="about__address-text">
                      3A Smart Crackers, RSK FANCY Agency, Kalugumalai Road, Vembakottai, Sivakasi – 626131
                    </p>
                  </div>
                  <span className="about__address-arrow" aria-hidden="true">→</span>
                </a>
              </div>
            </div>
          </Col>

        </Row>
      </Container>
    </section>
  );
};
